.ct{aspect-ratio:1/1;}